<template>
  <Select
    :options="options"
    :placeholder="$t('callable-users.placeholder')"
    v-bind="$attrs"
    v-on="$listeners"
  >
    <template v-slot:selected-option="option">
      <Icon v-if="option.type" :id="option.type" class="mrgr--" />
      {{ option.label }}
    </template>

    <template v-slot:option="option">
      <Icon v-if="option.type" :id="option.type" class="mrgr--" />
      {{ option.label }}
    </template>
  </Select>
</template>

<script>
import Select from '@/components/ui/Select';

export default {
  components: {
    Select,
  },

  inheritAttrs: false,

  computed: {
    options() {
      return Object.values(this.$store.state.users.index);
    },
  },
};
</script>
